import React, { useMemo } from 'react';
import '../styles/FallingSnow.css';

/**
 * FallingSnow Component
 * 
 * Renders lightweight falling snowflakes with light-blue color.
 * Uses CSS animations for optimal performance.
 * 
 * Props:
 *   - isActive: boolean - Whether to show the snow effect
 */
export default function FallingSnow({ isActive = true }) {
  // Generate snowflakes with random properties on mount
  const snowflakes = useMemo(() => {
    if (!isActive) return [];
    
    const count = 50; // Number of snowflakes
    const flakes = [];
    
    for (let i = 0; i < count; i++) {
      flakes.push({
        id: i,
        left: Math.random() * 100, // Random horizontal position (0-100%)
        delay: Math.random() * 10, // Random animation delay (0-10s)
        duration: 10 + Math.random() * 10, // Random fall duration (10-20s)
        opacity: 0.3 + Math.random() * 0.7, // Random opacity (0.3-1)
        size: 10 + Math.random() * 15, // Random size (10-25px)
      });
    }
    
    console.log('FallingSnow - isActive:', isActive, 'flakeCount:', flakes.length);
    return flakes;
  }, [isActive]);

  if (!isActive || snowflakes.length === 0) {
    console.log('FallingSnow - Returning null: isActive=', isActive, 'snowflakes.length=', snowflakes.length);
    return null;
  }

  console.log('FallingSnow - Rendering', snowflakes.length, 'snowflakes');
  return (
    <div className="falling-snow-container" aria-hidden="true">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            left: `${flake.left}%`,
            '--animation-delay': `${flake.delay}s`,
            '--animation-duration': `${flake.duration}s`,
            '--flake-opacity': flake.opacity,
            '--flake-size': `${flake.size}px`,
          }}
        >
          ❄
        </div>
      ))}
    </div>
  );
}
